<div mat-dialog-content class="material-admin-colors">
  <form class="license-form row" #form="ngForm" (ngSubmit)='save()'>

    <div class="modal-main-area">
      <mat-form-field class="col-md-6 col-sm-12 mb-0">
        <mat-label>First Name</mat-label>
        <input matInput type="text" required placeholder="First Name" #firstName="ngModel" name="firstName"
          [(ngModel)]="requestLicense.FirstName" required>
        <mat-error *ngIf="firstName.invalid && firstName.hasError('required')">First Name field is required</mat-error>
      </mat-form-field>

      <mat-form-field class="col-md-6 col-sm-12 mb-0">
        <mat-label>Last Name</mat-label>
        <input matInput type="text" required placeholder="Last Name" #lastName="ngModel" name="lastName"
          [(ngModel)]="requestLicense.LastName" required>
        <mat-error *ngIf="lastName.invalid && lastName.hasError('required')">Last Name field is required</mat-error>
      </mat-form-field>

      <mat-form-field class="col-md-6 col-sm-12 mb-0">
        <mat-label>Company`s Name</mat-label>
        <input matInput type="text" required placeholder="Company`s Name" #companyName="ngModel" name="companyName"
          [(ngModel)]="requestLicense.CompanyName" required>
        <mat-error *ngIf="companyName.invalid && companyName.hasError('required')">Company`s Name field is required
        </mat-error>
      </mat-form-field>

      <mat-form-field class="col-md-6 col-sm-12 mb-0">
        <mat-label>Email Adress</mat-label>
        <input matInput type="text" required placeholder="Email" #email="ngModel" name="email"
          [(ngModel)]="requestLicense.EmailAddress" required email>
        <mat-error *ngIf="email.invalid && email.hasError('required')">Email field is required</mat-error>
        <mat-error *ngIf="email.invalid && email.hasError('email')">Email field is not valid</mat-error>
      </mat-form-field>

      <mat-form-field class="col-md-6 col-sm-12 mb-0">
        <mat-label>Phone Number</mat-label>
        <input matInput type="tel" required placeholder="Phone Number" #phone="ngModel" name="phone"
          [(ngModel)]="requestLicense.PhoneNumber" required>
        <mat-error *ngIf="phone.invalid && phone.hasError('required')">Phone Number field is required</mat-error>
      </mat-form-field>

      <mat-form-field class="col-md-6 col-sm-12 mb-0">
        <mat-label>Activation Key</mat-label>
        <input matInput type="text" required placeholder="Activation Key" #activationKey="ngModel" name="activationKey"
          [(ngModel)]="requestLicense.ActivationKey" required>
        <mat-error *ngIf="activationKey.invalid && activationKey.hasError('required')">Activation Key field is required
        </mat-error>
      </mat-form-field>
    </div>

    <div class="row no-gutters mt-5 w-100">
      <hr class="my-3 w-100">
      <p>Please send the generated license file to <a
          href="mailto:licenses@monitorsanywhere.com">licenses&#64;monitorsanywhere.com</a> </p>
      <div class="d-flex justify-content-between align-content-center w-100">
        <button mat-raised-button class="btn-green" [disabled]="form.pristine || form.invalid" #submit
          type="submit">Generate license request</button>
        <button type="button" mat-raised-button (click)="close()" class="no-click">
          Close
        </button>
      </div>
    </div>
  </form>
</div>